/**
 * CRYIN — Magnetic Hover Effect
 * Clickable elements subtly follow the mouse cursor on hover.
 * Light, refined micro-interaction.
 */

(function () {
  'use strict';

  // Respect user motion preference and merchant toggle (window.CRYIN.animations).
  // If reduced motion or animations disabled, do not initialize magnetic effect.
  if (typeof window !== 'undefined') {
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const merchantDisabled = window.CRYIN && window.CRYIN.animations === false;
    if (reduceMotion || merchantDisabled) return;
  }

  const STRENGTH = 0.15;
  const STRENGTH_SMALL = 0.25;
  const EASE_SNAP = 'transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.1)';

  const SELECTORS = [
    'a:not(.pdp__snap-panel--prev):not(.pdp__snap-panel--next)',
    'button',
    '.product-card',
    '.pdp__dot',
    '.pdp__size-btn',
    '.pdp__add-btn',
    '.pdp__sizes-help',
    '.pdp__size-guide-table th',
    '.pdp__size-guide-table td',
    '.pdp__sizes-close',
    '.pdp__info-toggle',
    '.header__theme-toggle',
    '.header__toggle',
    '.header__cart',
    '.header__nav-link',
    '.footer__link',
    '.footer__social-link'
  ].join(', ');

  let active = null;
  let rafId = null;
  let mx = 0;
  let my = 0;

  function getStrength(el) {
    const rect = el.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    return size < 50 ? STRENGTH_SMALL : STRENGTH;
  }

  function tick() {
    if (!active) return;
    const rect = active.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const s = getStrength(active);
    const dx = (mx - cx) * s;
    const dy = (my - cy) * s;
    active.style.transition = 'transform 0.2s ease-out';
    active.style.transform = `translate(${dx}px, ${dy}px)`;
    rafId = null;
  }

  document.addEventListener('mousemove', (e) => {
    mx = e.clientX;
    my = e.clientY;
    if (active && !rafId) rafId = requestAnimationFrame(tick);
  }, { passive: true });

  document.addEventListener('mouseenter', (e) => {
    const el = e.target instanceof Element ? e.target.closest(SELECTORS) : null;
    if (el) active = el;
  }, { capture: true, passive: true });

  document.addEventListener('mouseleave', (e) => {
    const el = e.target instanceof Element ? e.target.closest(SELECTORS) : null;
    if (el && active === el) {
      el.style.transition = EASE_SNAP;
      el.style.transform = '';
      active = null;
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
    }
  }, { capture: true, passive: true });

})();
